import { _ as _sfc_main } from "./VaStepperStepButton.vue_vue_type_script_lang-568be858.mjs";
import { resolveComponent, openBlock, createElementBlock, mergeProps, withKeys, createElementVNode, createBlock, Fragment, createTextVNode, toDisplayString } from "vue";
import { _ as _export_sfc } from "../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaStepperStepButton_vue_vue_type_style_index_0_lang = "";
const _hoisted_1 = { class: "va-stepper__step-button__icon" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_va_icon = resolveComponent("va-icon");
  return openBlock(), createElementBlock("li", mergeProps({
    ref: "stepElement",
    class: ["va-stepper__step-button", _ctx.computedClass],
    onClick: _cache[0] || (_cache[0] = ($event) => !_ctx.$props.navigationDisabled && _ctx.$props.stepControls.setStep(_ctx.$props.stepIndex)),
    onKeyup: [
      _cache[1] || (_cache[1] = withKeys(($event) => !_ctx.$props.navigationDisabled && _ctx.$props.stepControls.setStep(_ctx.$props.stepIndex), ["enter"])),
      _cache[2] || (_cache[2] = withKeys(($event) => !_ctx.$props.navigationDisabled && _ctx.$props.stepControls.setStep(_ctx.$props.stepIndex), ["space"]))
    ]
  }, _ctx.ariaAttributesComputed, {
    style: `--va-0-stepper-color: ${String(_ctx.stepperColor)}`
  }), [
    createElementVNode("div", _hoisted_1, [
      _ctx.step.icon ? (openBlock(), createBlock(_component_va_icon, {
        key: 0,
        name: _ctx.step.icon,
        size: "1.3rem"
      }, null, 8, ["name"])) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
        createTextVNode(toDisplayString(_ctx.$props.stepIndex + 1), 1)
      ], 64))
    ]),
    createTextVNode(" " + toDisplayString(_ctx.step.label), 1)
  ], 16);
}
const VaStepperStepButton = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  VaStepperStepButton as V
};
//# sourceMappingURL=VaStepperStepButton-b96dd205.mjs.map
